import styled from '@emotion/styled';
import { GEL_SPACING_TRPL } from '#psammead/gel-foundations/src/spacings';

const InlineSpan = styled.span`
  padding-bottom: ${GEL_SPACING_TRPL};
  margin: 0; /* Reset */
`;

export default InlineSpan;
